import { useState } from 'react';

import POSHeaderFields from './POSHeaderFields';

import usePOSHeader from '../../../hooks/sale/usePOSHeader';
import { useSale } from '../../../hooks/sale/useSale';
import { useSalesTipSettings } from '../../../hooks/sale/useSalesTipSettings';
import { DOCUMENT_TYPE_CODES } from '../../../constants/documentTypeCodes';
import Checkbox from '../../Forms/Input/Checkbox';

const POSHeaderBar = () => {
  // =====================================================
  // 🔹 POS Header Logic
  // =====================================================
  const props = usePOSHeader();

  // =====================================================
  // 💵 Propina opcional de POS
  // =====================================================
  const { form, activeDocumentType, handlerApplyTip, handlerRemoveTip } =
    useSale();
  const { tipEnabled: tipSettingEnabled } = useSalesTipSettings(
    form.branch?.id
  );
  const [tipPending, setTipPending] = useState(false);

  const isTipEligibleDocument =
    activeDocumentType?.code === DOCUMENT_TYPE_CODES.INVOICE ||
    activeDocumentType?.code === DOCUMENT_TYPE_CODES.TAX_CREDIT;

  const showTipCheckbox =
    tipSettingEnabled && isTipEligibleDocument && !!form.id;

  // La venta nace cobrando propina (lo decide el backend al generarla,
  // según la config de la sucursal); como la respuesta de "generar venta"
  // no trae este campo, solo lo tratamos como destildado cuando el backend
  // ya confirmó explícitamente false (ej. tras quitar la propina y
  // refrescar con handlerGetSaleForEdit).
  const tipChecked = form.tipChargeRequested !== false;

  const handleToggleTip = async () => {
    if (!form.id || tipPending) return;

    try {
      setTipPending(true);
      if (tipChecked) {
        await handlerRemoveTip(form.id);
      } else {
        await handlerApplyTip(form.id);
      }
    } finally {
      setTipPending(false);
    }
  };

  // =====================================================
  // 🎨 Render
  // =====================================================
  return (
    <div
      className="
        rounded-2xl
        border
        border-stroke

        bg-white

        p-4

        shadow-sm

        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {showTipCheckbox && (
        <div className="mb-4 w-fit rounded bg-amber-50 px-3 py-2 dark:bg-amber-900/30">
          <Checkbox
            label="Cobrar propina"
            checked={tipChecked}
            disabled={tipPending}
            onChange={handleToggleTip}
            className="text-amber-900 dark:text-amber-200"
          />
        </div>
      )}

      <POSHeaderFields {...props} />
    </div>
  );
};

export default POSHeaderBar;